<app-statistik-ydelse-options class="d-flex"
                              (selectLedelseAnsvarlig)="onLedelseAnsvarligSelected($event)"
                              (selectKundeAnsvarlig)="onKundeAnsvarligSelected($event)"
                              (selectSagsAnsvarlig)="onSagsAnsvarligeSelected($event)"
                              (selectHourFormat)="onHourFormatSelected($event)"
                              (periodeChange)="onPeriodeChange($event)"
                              (exportExcel)="onExport()"
                              [laID]="laID"
                              [kaID]="kaID"
                              [saID]="saID"
                              [periode]="periode"
                              [laCards]="laCards"
                              [kaCards]="kaCards"
                              [saCards]="saCards"
                              ></app-statistik-ydelse-options>
<div class="table__viewport">
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
        <tr>
            <th>Kundenr.</th>
            <th>Kunde</th>
            <th class="text-end" *ngFor="let ydelse of filteredYdelserList">{{ ydelse.navn }}</th>
            <th class="text-end">Total</th>
        </tr>
        </thead>
        <tbody>
            <tr *ngFor="let kunde of kundelistWithYdelser;">
                <td class="text-end">{{kunde.glKundeNr}}</td>
                <td>{{kunde.kunde }}</td>
                <td class="text-end" *ngFor="let ydelse of filteredYdelserList">{{ kunde.ydelser | ydelseTimerKroner:ydelse.id:hourFormat | timeKrFormat: hourFormat: 0: false }}</td>
                <td class="text-end">{{getTotalOfKunde(kunde) | timeKrFormat: hourFormat: 0: false}}</td>
            </tr>
        </tbody>
        <tfoot class="fixed-bottom position-fixed position-sticky">
            <tr>
                <th></th>
                <th>Total</th>
                <th class="text-end" *ngFor="let ydelse of filteredYdelserList">{{ totalByYdelse(ydelse.id) | timeKrFormat: hourFormat: 0: false }}</th>
                <th class="text-end">{{TotalOfTotals() | timeKrFormat: hourFormat: 0: false}}</th>
            </tr>
        </tfoot>
    </table>
</div>
